module.exports = __webpack_public_path__ + "img/soft_16.8f0309c7.png";